export default __webpack_public_path__ + "static/media/linkedin.b7b1c253.jpg";